import { Routes } from '@angular/router';
import { createDashboardRoute } from './constants/route_generation';
import { Login } from './features/authentication/login/login';
import { Installations } from './features/backoffice/installations/installations';
import { Landing as BackofficeLanding } from './features/backoffice/landing/landing';
import { Monitoring } from './features/backoffice/monitoring/monitoring';
import { Overviews } from './features/backoffice/overviews/overviews';
import { Permissions } from './features/backoffice/permissions/permissions';
import { AddUser } from './features/backoffice/users/add-user/add-user';
import { Users } from './features/backoffice/users/users';
import { Detail } from './features/dashboard/detail/detail';
import { Landing as DashboardLanding } from './features/dashboard/landing/landing';
import { Forbidden } from './features/forbidden/forbidden';
import { adminGuard } from './guards/admin-guard';
import { AuthGuard } from './guards/auth-guard';
import { LoggedIn as LoggedInLayout } from './layout/logged-in/logged-in';

export const routes: Routes = [
  { path: '', component: Login },
  { path: 'login', component: Login },
  {
    path: '',
    component: LoggedInLayout,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardLanding,
      },
      {
        path: 'dashboard/installation/:installationId/controller/:controllerId',
        component: Detail,
      },
      {
        path: 'backoffice',
        component: BackofficeLanding,
        canActivate: [adminGuard],
        children: [
          {
            path: 'users',
            component: Users,
            title: 'Users',
          },
          {
            path: 'users/add',
            component: AddUser,
            title: 'Add user',
          },
          {
            path: 'monitoring',
            component: Monitoring,
            title: 'Monitoring',
          },
          {
            path: 'installation',
            component: Installations,
            title: 'Installations',
          },
          {
            path: 'permission',
            component: Permissions,
            title: 'Permissions',
          },
          {
            path: 'overview',
            component: Overviews,
            title: 'Overviews',
          },
        ],
      },
      { path: '', redirectTo: createDashboardRoute, pathMatch: 'full' },
      { path: 'forbidden', component: Forbidden },
    ],
  },
  { path: '**', redirectTo: createDashboardRoute() },
];
